import {Button, Popup} from "semantic-ui-react";
import * as React from "react";

export function TagOrSelectionHelpButton(){
    return  <Popup content='Qualifier: ' trigger={
        <Button mini icon={'question'}/>
    }>
        <Popup.Header>Description</Popup.Header>
        <Popup.Content>
            <h4>Suffixes</h4>
            <ul>
                <li>! - Trim the ; char</li>
                <li>! - Trim the ; and whitespace chars</li>
                <li>? - Remove entry without data</li>
                <li>$ - Take first value</li>
                <li>+ - Ist verkettet</li>
                <li>(Default) - take last value</li>
            </ul>
            <h4>Other</h4>
            <ul>
                <li>= Assign static value</li>
                <li>$anyVarName - Define variable</li>
            </ul>
        </Popup.Content>
    </Popup>
}